export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Name des Coaching-Gesprächsleiters/ der Coaching-Gesprächsleiterin (im Folgenden Dozent/ Dozentin): ",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "Der für mein Klausur-Coaching zuständige Dozent / die für mein Klausur-Coaching zuständige Dozentin war engagiert und motiviert.",
			},
			{
				id: 3,
				text: "Ich hatte genug Zeit, um dem Dozenten oder der Dozentin Fragen zu stellen.",
			},
			{
				id: 4,
				text: "Der Dozent / die Dozentin hat Termine und Verfahren des Klausur-Coachings gut organisiert.",
			},
			{
				id: 5,
				text: "Durch den Inhalt des Klausur-Coachings habe ich zu meiner Bearbeitung der Probeklausur ein individuelles Feedback erhalten.",
			},
			{
				id: 6,
				text: "Der Inhalt des Klausur-Coachings hat mir gegenüber der allgemeinen Besprechung der Probeklausur in einer Arbeitsgemeinschaft einen Mehrwert geboten.",
			},
			{
				id: 7,
				text: "Durch das Klausur-Coaching wurde mir verdeutlicht, wo die Stärken und Schwächen meiner Klausur lagen, wodurch die Benotung besser nachvollziehbar wurde.",
			},
			{
				id: 8,
				text: "Die Gründe für die erfolgte Benotung der Probeklausur wurden mir nähergebracht.",
			},
			{
				id: 9,
				text: "Durch das Klausur-Coaching ist mir bewusster geworden, was in einer zivilrechtlichen Klausur grundsätzlich erwartet wird.",
			},
			{
				id: 10,
				text: "Durch das Klausur-Coaching weiß ich genauer, wie ich mich auf die Abschlussklausuren vorbereiten sollte.",
			},
			{
				id: 11,
				text: "Aus dem Coaching habe ich Nützliches für die Herangehensweise bei einer Klausurbearbeitung mitgenommen.",
			},
			{
				id: 12,
				text: "Ich habe den Eindruck, dass das Coaching mir bei der Verbesserung des juristischen Gutachtenstils geholfen hat.",
			},
			{
				id: 13,
				text: "Die Vereinbarung eines Coaching-Termins war unkompliziert.",
			},
			{
				id: 14,
				text: "Die Veranstaltungen begannen pünktlich.",
			},
			{
				id: 15,
				text: "Das Klausur-Coaching ist eine gute Ergänzung zum Programm der Vorlesung Bürgerliches Vermögensrecht I und sollte auch im zweiten Semester fortgeführt werden.",
			},
			{
				id: 16,
				text: "Ich würde die Teilnahme an dem Klausur-Coaching kommenden Erstsemester-Studierenden weiterempfehlen.",
			},
		],
	},
	{
		type: "special",
		id: 3,
		items: [
			{
				id: 17,
				text: "Mir ist bekannt, dass diese Maßnahme „Klausur-Coaching“ für Erstsemester erst zum zweiten Male angeboten wurde.",
				label: [
					{
						id: 1,
						text: "Ja",
					},
					{
						id: 2,
						text: "Nein",
					},
				],
			},
			{
				id: 18,
				text: "Das Klausur-Coaching fand statt als:",
				label: [
					{
						id: 1,
						text: "Präsenzveranstaltung",
					},
					{
						id: 2,
						text: "Online-Besprechung",
					},
				],
			},
			{
				id: 19,
				text: "Bei einem (erneuten) Klausur-Coaching würde ich folgende Form bevorzugen:",
				label: [
					{
						id: 1,
						text: "Präsenzveranstaltung",
					},
					{
						id: 2,
						text: "Online-Besprechung",
					},
				],
			},
			{
				id: 20,
				text: "Mein Klausur-Coaching fand statt als",
				label: [
					{
						id: 1,
						text: "Einzelgespräch",
					},
					{
						id: 2,
						text: "Gespräch mit zwei Studierenden",
					},
					{
						id: 3,
						text: "Gespräch mit drei Studierenden",
					},
					{
						id: 4,
						text: "Andere Form (bitte angeben)",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 21,
				text: "Falls Sie bei der letzten Frage 'Andere Form' ausgewählt haben, geben Sie die Form bitte hier ein:",
				type: "medium",
			},
		],
	},
];
